// file path: src\services\project-section.service.ts

import axios from "axios";
import { apiBaseUrl } from "../config";
import { getApiPrefix, getAuthHeader } from "./auth.service";

export interface ProjectSection {
    id: number;
    project_id: number;
    name: string;
    position: number;
    created_at?: string;
    updated_at?: string;
}

export function fetchSections(projectId: number, role: string = 'super-admin'): Promise<ProjectSection[]> {
    return axios.get(apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/project-sections`, getAuthHeader())
        .then((res) => res.data);
}

export function createSection(projectId: number, name: string, position: number, role: string = 'super-admin'): Promise<ProjectSection> {
    return axios.post(
        apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/project-sections`,
        { name, position },
        getAuthHeader()
    ).then((res) => res.data);
}

export function updateSection(projectId: number, sectionId: number, name: string, role: string = 'super-admin'): Promise<ProjectSection> {
    return axios.put(
        apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/project-sections/${sectionId}`,
        { name },
        getAuthHeader()
    ).then((res) => res.data);
}

export function updateSectionPositions(
    projectId: number,
    sections: { name: string; position: number }[],
    role: string = 'super-admin'
): Promise<ProjectSection[]> {
    return axios.put(
        apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/project-sections/positions`,
        { sections },
        getAuthHeader()
    ).then((res) => res.data);
}

export function deleteSection(projectId: number, sectionId: number, role: string = 'super-admin'): Promise<void> {
    return axios.delete(
        apiBaseUrl + getApiPrefix(role) + `projects/${projectId}/project-sections/${sectionId}`,
        getAuthHeader()
    ).then((res) => res.data);
}
